import PropTypes from '@root/vendor/prop-types';
import React, { useContext } from '@root/vendor/react';

const BoomerangContext = React.createContext();

export default function BoomerangContextProvider({
  children, boomerangContext, onReloadBoomerangContext,
}) {
  return (
    <BoomerangContext.Provider
      value={{
        boomerangContext,
        reloadBoomerangContext: onReloadBoomerangContext,
      }}
    >
      {children}
    </BoomerangContext.Provider>
  );
}

BoomerangContextProvider.propTypes = {
  boomerangContext: PropTypes.object,
  children: PropTypes.node.isRequired,
  onReloadBoomerangContext: PropTypes.func.isRequired,
};

export function useBoomerangContext() {
  const { boomerangContext, reloadBoomerangContext } = useContext(BoomerangContext);

  return {
    boomerangContext,
    reloadBoomerangContext,
  };
}
